import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Currency } from '../currency';
import { HttpService } from '../service/http.service';
import { SalesProductType } from '../sales-product-type';
import { ToastMessageService } from '../toast-message.service';
import * as moment from 'moment';
import Decimal from 'decimal.js';
import { CKEDITORCONFIGMINIMAL, CKEDITORCONFIGMINIMALWITHLINK } from '../ckeditor-config';
import { Observable } from 'rxjs';
import { QuotationTemplate } from '../quotation-template';
import { QuotationTemplateProduct } from '../quotation-template-product';
import { School } from '../school';
import { Language } from '../language';
import { SchoolListItem } from '../school-list-item';
import * as Editor from '../../libs/ckeditor';

@Component({
  selector: 'app-create-quotation-template',
  templateUrl: './create-quotation-template.component.html',
  styleUrls: ['./create-quotation-template.component.css']
})
export class CreateQuotationTemplateComponent implements OnInit {

  templateForm!: FormGroup
  productTypes: SalesProductType[] = [];
  currencies: Currency[] = [];
  schoolList: SchoolListItem[] = [];
  languageList: Language[] = [];

  productPriceInCurrency: Observable<string>[] = [];
  productPriceInSecondCurrency: Observable<string>[] = [];

  editorConfig = CKEDITORCONFIGMINIMAL;
  descriptionEditorConfig = CKEDITORCONFIGMINIMALWITHLINK;

  yearRange = (moment().year() - 10) + ":" + (moment().year() + 4);

  public Editor = Editor;

  constructor(
    private httpService: HttpService,
    private builder: FormBuilder,
    private toastService: ToastMessageService
  ) { }

  ngOnInit(): void {
    this.httpService.getCurrencies().subscribe(currencies => {
      this.currencies = currencies;
    });
    this.httpService.getSchools().subscribe(res => this.schoolList = res);
    this.httpService.getLanguages().subscribe(res => this.languageList = res);
    this.httpService.getSalesProductTypes().subscribe(res => this.productTypes = res);
    this.templateForm = this.builder.group({
      name: "",
      description: "",
      comment: "",
      products: this.builder.array([]),
      baseCurrency: new Currency(1, "Euro", "EUR", "€"),
      secondCurrency: null,
      quotationDate: moment().toDate(),
      dueDate: null,
      deposit: new Decimal(250.00),
      priceIncludes: "",
      priceNotIncludes: "",
      school: [null, Validators.required],
      language: [null, Validators.required]
    });
  }

  mouseover(i: number) {
    let array = this.templateForm.get("products") as FormArray;
    array.controls[i].get("activeMenu")!.setValue(true);
  }
  mouseout(i: number) {
    let array = this.templateForm.get("products") as FormArray;
    array.controls[i].get("activeMenu")!.setValue(false);
  }

  moveItem(array: any[], i: number, delta: number) {
    let newIndex = i + delta;
    if (newIndex < 0 || newIndex >= array.length) {
      return;
    }
    let indexes = [i, newIndex].sort();
    array.splice(indexes[0], 2, array[indexes[1]], array[indexes[0]]);
  }

  moveUp(i: number) {
    let itemArray = this.templateForm.get("products") as FormArray;
    this.moveItem(itemArray.controls, i, -1);
  }

  moveDown(i: number) {
    let itemArray = this.templateForm.get("products") as FormArray;
    this.moveItem(itemArray.controls, i, 1);
  }

  insertAt(array: AbstractControl[], index: number, element: FormGroup) {
    array.splice(index, 0, element);
  }

  insertItem(i: number) {
    let itemArray = this.templateForm.get("products") as FormArray;
    this.insertAt(itemArray.controls, i + 1, this.builder.group({
      type: this.productTypes[0],
      description: "",
      amount: [new Decimal(0.00), Validators.pattern(/^[.\d]+$/)],
      currency: new Currency(1, "Euro", "EUR", "€"),
      activeMenu: false
    }));
  }

  removeItem(i: number) {
    let itemArray = this.templateForm.get("products") as FormArray;
    itemArray.controls.splice(i, 1);
  }

  createQuotation() {
    if(this.templateForm.invalid){
      this.toastService.addError("Error", "Please complate the form.");
      return;
    }
    this.httpService.checkIfTemplateNameExists(this.templateForm.value.name, this.templateForm.value.school.id, this.templateForm.value.language.id)
    .subscribe(res => {
      if(res == false){
        let template = new QuotationTemplate(
          this.templateForm.value.name,
          this.templateForm.value.description,
          this.templateForm.value.comment,
          this.templateForm.value.baseCurrency,
          this.getProductList(),
          this.templateForm.value.priceIncludes,
          this.templateForm.value.priceNotIncludes,
          this.templateForm.value.school,
          this.templateForm.value.language,
          this.templateForm.value.secondCurrency
        );

        if(template.products.length == 0){
          this.toastService.addError("Error", "Sales item is empty.");
          return;
        }
        this.httpService.postQuotationTemplate(template).subscribe(() => {
          this.toastService.addSuccess("Success", "Template saved");
        }, error => this.toastService.addError("Error", error.message));
      } else {
        this.toastService.addError("Error", "This name exist already for this school and language.");
      }
    });
  }

  getProductList() {
    let products = [];
    let productFormArray = this.templateForm.get("products") as FormArray;
    for (let product of productFormArray.controls) {
      products.push(new QuotationTemplateProduct(
        product.get("type")!.value,
        product.get("description")!.value,
        new Decimal(product.get("amount")!.value),
        product.get("currency")!.value
      ));
    }
    return products;
  }

  get productFormArray(){
    let formArray = this.templateForm.get('products') as FormArray;
    return formArray.controls;
  }

  isHidden(index: number){
    let formArray = this.templateForm.get('products') as FormArray;
    if(formArray.controls[index].get('activeMenu')!.value){
      return false;
    }
    return true;
  }

}
